<template>
  <v-dialog v-model="dialog" max-width="600">
    <v-card
      :prepend-icon="mdiLock"
      class="font-futura"
      :title="$t('reset-password')"
    >
      <v-form ref="form" @submit.prevent>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="12" sm="12">
              <v-text-field
                class="font-egyptienne"
                :label="$t('email') + '*'"
                :rules="emailRules"
                v-model="email"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="mb-3 font-futura-very-small">
            {{ $t("link-reset-password") }}
          </div>
          <small
            class="text-caption text-medium-emphasis font-futura-button"
          >
            {{ $t("require-fields") }}
          </small>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            :text="$t('close')"
            variant="plain"
            @click="close"
            class="font-futura-button"
          ></v-btn>

          <v-btn
            color="#ffb500"
            type="submit"
            :text="$t('send')"
            variant="tonal"
            @click="submit"
            @keydown.enter.prevent="submit"
            class="font-futura-button"
          ></v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiLock } from "@mdi/js";

export default {
  name: "AddEditAddress",
  props: ["modelDialog"],
  data() {
    return {
      mdiLock,
      email: "",
      emailRules: [
        (value) => {
          if (value) return true;
          return this.$t("rules.required");
        },
        (value) => {
          if (/.+@.+\..+/.test(value)) return true;
          return this.$t("rules.email-valid");
        }
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.$store
          .dispatch("auth/askResetPassword", this.email)
          .then(() => {
            this.loading = false;
            this.$store.dispatch("showSnackbar", {
              message: this.$t("success.email-send-reset-password"),
              color: "success"
            });
            this.close();
          })
          .catch(() => {
            this.loading = false;
            this.$store.dispatch("showSnackbar", {
              message: this.$t("errors.email-send-reset-password"),
              color: "error"
            });
          });
      } else {
        this.loading = false;
        this.$store.dispatch("showSnackbar", {
          message: this.$t("rules.email-valid"),
          color: "error"
        });
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
